import PropTypes from "prop-types";
import React from "react";

import { FieldValueWrapper, isFieldValueWrapper } from "@elastic/react-search-ui-views/lib/types/FieldValueWrapper";
import { getUrlSanitizer } from "@elastic/react-search-ui-views/lib/view-helpers/getUrlSanitizer";
import MealDetailView from "./meal-detail-view";

var isOpen = true;

function getFieldType(result, field, type) {
    if (result[field]) return result[field][type];
  }
  
  function getRaw(result, field) {
    return getFieldType(result, field, "raw");
  }
  
  function getSnippet(result, field) {
    return getFieldType(result, field, "snippet");
  }
  
  function htmlEscape(str) {
    if (!str) return "";
  
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
  
  function getEscapedField(result, field) {
    // Fallback to raw values here, because non-string fields
    // will not have a snippet fallback. Raw values MUST be html escaped.
    const safeField =
      getSnippet(result, field) || htmlEscape(getRaw(result, field));
    return Array.isArray(safeField) ? safeField.join(", ") : safeField;
  }
  
  function getEscapedFields(result) {
    return Object.keys(result).reduce((acc, field) => {
      // If we receive an arbitrary value from the response, we may not properly
      // handle it, so we should filter out arbitrary values here.
      //
      // I.e.,
      // Arbitrary value: "_metaField: '1939191'"
      // vs.
      // FieldValueWrapper: "_metaField: {raw: '1939191'}"
      if (!isFieldValueWrapper(result[field])) return acc; 
      return { ...acc, [field]: getEscapedField(result, field) };
    }, {});
  }

  function getIngredients(result) {
    var ingredients = formatIngredient(result.ingredient1, result.measure1);
    ingredients = appendIngredient(ingredients, result.ingredient2, result.measure2);
    ingredients = appendIngredient(ingredients, result.ingredient3, result.measure3);
    ingredients = appendIngredient(ingredients, result.ingredient4, result.measure4);
    return ingredients;
  }

  function appendIngredient(ingredients, ingredientToAdd, measureToAdd) {
    if (ingredientToAdd) {
      return ingredients + ", " + formatIngredient(ingredientToAdd, measureToAdd);
    } else {
      return ingredients;
    }
  }

  function formatIngredient(ingredient, measure) {
    return  ingredient.snippet + "(" + measure.snippet + ")"
  }

  function toggleModal() {
    console.log(`toggleModal(${isOpen})`);
    isOpen = !isOpen;
  }

  function Result({
    className,
    result,
    onClickLink,
    titleField,
    urlField,
    ...rest
  }) {

    const fields = getEscapedFields(result);
    const title = getEscapedField(result, titleField);
    //TODO: location undefined? const url = getUrlSanitizer(URL, location)(getRaw(result, urlField));
    const url = (getRaw(result, urlField));

    const ingredients = getIngredients(result);

    return (
        
        <li className="sui-result">
        <div className="sui-result__header">

            {title && !url && (
                <span
                    className="sui-result__title"
                    // Snippeted results contain search term highlights with html and are
                    // 100% safe and santitized, so we dangerously set them here
                    dangerouslySetInnerHTML={{ __html: result.name.snippet }}
                />
          )}
            {title && url && (
            <a
                className="sui-result__title sui-result__title-link"
                dangerouslySetInnerHTML={{ __html: title }}
                href={url}
                onClick={onClickLink}
                target="_blank"
                rel="noopener noreferrer"
            />
            )}
        </div>
        <div className="sui-result__body">
          <div
            className="sui-result__image"
            style={{
              maxWidth: "140px",
              paddingLeft: "24px",
              paddingTop: "10px"
            }}
          >
            <img
              src={result.meal_thumb.raw}
              alt="thumb"
              style={{
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center"
              }}
            />
          </div>
          <ul className="sui-result__details">
            <li>
              <span className="sui-result__key">Area</span>{" "}
              <span
                className="sui-result__value"
                dangerouslySetInnerHTML={{
                  __html: result.area.snippet
                }}
              />
            </li>
            <li>
              <span className="sui-result__key">Category</span>{" "}
              <span
                className="sui-result__value"
                dangerouslySetInnerHTML={{
                  __html: result.category.snippet
                }}
              />
            </li>
            <li>
              <span className="sui-result__key">Tags</span>{" "}
              <span
                className="sui-result__value"
                dangerouslySetInnerHTML={{
                  __html: result.tags.snippet
                }}
              />
            </li>
            <li>
              <span className="sui-result__key">Id</span>{" "}
              <span className="sui-result__value">{result.id.raw}</span>
            </li>
            {result.source.raw && (
              <li>
                <span className="sui-result__key">Source</span>{" "}
                <a
                    className="sui-result__value"
                    dangerouslySetInnerHTML={{ __html: title }}
                    href={result.source.raw}
                    onClick={onClickLink}
                    target="_blank"
                    rel="noopener noreferrer"
                />
              </li>
            )}
            {result.youtube.raw && (
              <li>
                <span className="sui-result__key">Youtube</span>{" "}
                <a
                    className="sui-result__value"
                    dangerouslySetInnerHTML={{ __html: title }}
                    href={result.youtube.raw}
                    onClick={onClickLink}
                    target="_blank"
                    rel="noopener noreferrer"
                />
              </li>
            )}
            <li>
              <span className="sui-result__key">Ingredients</span>{" "}
              <span className="sui-result__value">{ingredients}</span>
            </li>
          </ul>
        </div>
      </li>
    );
  }

  export default Result;

